import React, { Component } from "react";
import { fire, auth } from "../../firebase/index";
//? English Version
import loginInstruction1 from "../../assets/img/tutorialimages/loginGuide1.png";

import subscribeInstruction1 from "../../assets/img/tutorialimages/subscribeGuide1.png";
import subscribeInstruction2 from "../../assets/img/tutorialimages/subscribeGuide2.png";
import subscribeInstruction3 from "../../assets/img/tutorialimages/subscribeGuide3.png";

import addLockInstruction1 from "../../assets/img/tutorialimages/registerLockGuide1.png";
import addLockInstruction2 from "../../assets/img/tutorialimages/registerLockGuide2.png";
import addLockInstruction3 from "../../assets/img/tutorialimages/registerLockGuide3.png";

import inviteMembersIntruction1 from "../../assets/img/tutorialimages/addMemberGuide1.png";
import inviteMembersIntruction2 from "../../assets/img/tutorialimages/addMemberGuide2.png";
import inviteMembersIntruction3 from "../../assets/img/tutorialimages/addMemberGuide3.png";
import inviteMembersIntruction4 from "../../assets/img/tutorialimages/addMemberGuide4.png";

import addRecipient1 from "../../assets/img/tutorialimages/addRecipientGuide1.png";
import addRecipient2 from "../../assets/img/tutorialimages/addRecipientGuide2.png";

import shareLockInstruction1 from "../../assets/img/tutorialimages/shareLockGuide1.png";
import shareLockInstruction2 from "../../assets/img/tutorialimages/shareLockGuide2.png";
import shareLockInstruction3 from "../../assets/img/tutorialimages/shareLockGuide3.png";
import shareLockInstruction4 from "../../assets/img/tutorialimages/shareLockGuide4.png";
import shareLockInstruction5 from "../../assets/img/tutorialimages/shareLockGuide5.png";
import shareLockInstruction6 from "../../assets/img/tutorialimages/shareLockGuide6.png";
import shareLockInstruction7 from "../../assets/img/tutorialimages/shareLockGuide7.png";

import retractLockInstruction1 from "../../assets/img/tutorialimages/retractLockGuide1.png";
//? Japanese Version
import loginInstruction1Jap from "../../assets/img/tutorialimages/loginGuide1_Jap.png";

import subscribeInstruction1Jap from "../../assets/img/tutorialimages/subscribeGuide1_Jap.png";
import subscribeInstruction2Jap from "../../assets/img/tutorialimages/subscribeGuide2_Jap.png";
import subscribeInstruction3Jap from "../../assets/img/tutorialimages/subscribeGuide3_Jap.png";
import subscribeInstruction4Jap from "../../assets/img/tutorialimages/subscribeGuide4_Jap.png";
import subscribeInstruction5Jap from "../../assets/img/tutorialimages/subscribeGuide5_Jap.png";

import addLockInstruction1Jap from "../../assets/img/tutorialimages/registerLockGuide1_Jap.png";
import addLockInstruction2Jap from "../../assets/img/tutorialimages/registerLockGuide2_Jap.png";
import addLockInstruction3Jap from "../../assets/img/tutorialimages/registerLockGuide3_Jap.png";

import inviteMembersIntruction1Jap from "../../assets/img/tutorialimages/addMemberGuide1_Jap.png";
import inviteMembersIntruction2Jap from "../../assets/img/tutorialimages/addMemberGuide2_Jap.png";
import inviteMembersIntruction3Jap from "../../assets/img/tutorialimages/addMemberGuide3_Jap.png";
import inviteMembersIntruction4Jap from "../../assets/img/tutorialimages/addMemberGuide4_Jap.png";
import inviteMembersIntruction5Jap from "../../assets/img/tutorialimages/addMemberGuide5_Jap.png";

import addRecipient1Jap from "../../assets/img/tutorialimages/addRecipientGuide1_Jap.png";
import addRecipient2Jap from "../../assets/img/tutorialimages/addRecipientGuide2_Jap.png";

import shareLockInstruction1Jap from "../../assets/img/tutorialimages/shareLockGuide1_Jap.jpg";
import shareLockInstruction2Jap from "../../assets/img/tutorialimages/shareLockGuide2_Jap.jpg";
import shareLockInstruction3Jap from "../../assets/img/tutorialimages/shareLockGuide3_Jap.jpg";
import shareLockInstruction4Jap from "../../assets/img/tutorialimages/shareLockGuide4_Jap.jpg";
import shareLockInstruction5Jap from "../../assets/img/tutorialimages/shareLockGuide5_Jap.jpg";
import shareLockInstruction6Jap from "../../assets/img/tutorialimages/shareLockGuide6_Jap.jpg";
import shareLockInstruction7Jap from "../../assets/img/tutorialimages/shareLockGuide7_Jap.jpg";
import shareLockInstruction8Jap from "../../assets/img/tutorialimages/shareLockGuide8_Jap.jpg";

import retractLockInstruction1Jap from "../../assets/img/tutorialimages/retractLockGuide1_Jap.png";

class FullGuide extends Component {
  componentWillMount() {
    //! FOR LANGUAGE SETTINGS
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }
  }
  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    if (this.state.currentLanguage === "en") {
      return (
        <div
          style={{
            width: "60%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <h2
            style={{
              backgroundColor: "#5096ff",
              padding: "20px",
              color: "white",
            }}
          >
            Login Guide
          </h2>
          <img
            className="imgStyle"
            src={loginInstruction1}
            alt="loginInstruction1"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <h2
            style={{
              backgroundColor: "#5096ff",
              padding: "20px",
              color: "white",
            }}
          >
            Subscribe Guide
          </h2>
          <img
            className="imgStyle"
            src={subscribeInstruction1}
            alt="subscribeInstruction1"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={subscribeInstruction2}
            alt="subscribeInstruction2"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={subscribeInstruction3}
            alt="subscribeInstruction3"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <h2
            style={{
              backgroundColor: "#5096ff",
              padding: "20px",
              color: "white",
            }}
          >
            Add Lock Guide
          </h2>
          <img
            className="imgStyle"
            src={addLockInstruction1}
            alt="addLockInstruction1"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={addLockInstruction2}
            alt="addLockInstruction2"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={addLockInstruction3}
            alt="addLockInstruction3"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <h2
            style={{
              backgroundColor: "#5096ff",
              padding: "20px",
              color: "white",
            }}
          >
            Invite Member Guide
          </h2>
          <img
            className="imgStyle"
            src={inviteMembersIntruction1}
            alt="inviteMembersIntruction1"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={inviteMembersIntruction2}
            alt="inviteMembersIntruction2"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={inviteMembersIntruction3}
            alt="inviteMembersIntruction3"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={inviteMembersIntruction4}
            alt="inviteMembersIntruction4"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <h2
            style={{
              backgroundColor: "#5096ff",
              padding: "20px",
              color: "white",
            }}
          >
            Add Recipient Guide
          </h2>
          <img
            className="imgStyle"
            src={addRecipient1}
            alt="addRecipient1"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={addRecipient2}
            alt="addRecipient2"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <h2
            style={{
              backgroundColor: "#5096ff",
              padding: "20px",
              color: "white",
            }}
          >
            Share Lock Guide
          </h2>
          <img
            className="imgStyle"
            src={shareLockInstruction1}
            alt="shareLockInstruction1"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={shareLockInstruction2}
            alt="shareLockInstruction2"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={shareLockInstruction3}
            alt="shareLockInstruction3"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={shareLockInstruction4}
            alt="shareLockInstruction4"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={shareLockInstruction5}
            alt="shareLockInstruction5"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={shareLockInstruction6}
            alt="shareLockInstruction6"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={shareLockInstruction7}
            alt="shareLockInstruction7"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <h2
            style={{
              backgroundColor: "#5096ff",
              padding: "20px",
              color: "white",
            }}
          >
            Retract Guide
          </h2>
          <img
            className="imgStyle"
            src={retractLockInstruction1}
            alt="retractLockInstruction1"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
        </div>
      );
    } else if (this.state.currentLanguage === "ja") {
      return (
        <div
          style={{
            width: "60%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <h2
            style={{
              backgroundColor: "#5096ff",
              padding: "20px",
              color: "white",
            }}
          >
            新規登録・ログイン
          </h2>
          <img
            className="imgStyle"
            src={loginInstruction1Jap}
            alt="loginInstruction1Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <h2
            style={{
              backgroundColor: "#5096ff",
              padding: "20px",
              color: "white",
            }}
          >
            プラン選択・ご契約
          </h2>
          <img
            className="imgStyle"
            src={subscribeInstruction1Jap}
            alt="subscribeInstruction1Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={subscribeInstruction2Jap}
            alt="subscribeInstruction2Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={subscribeInstruction3Jap}
            alt="subscribeInstruction3Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={subscribeInstruction4Jap}
            alt="subscribeInstruction4Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={subscribeInstruction5Jap}
            alt="subscribeInstruction5Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <h2
            style={{
              backgroundColor: "#5096ff",
              padding: "20px",
              color: "white",
            }}
          >
            スマートロック登録
          </h2>
          <img
            className="imgStyle"
            src={addLockInstruction1Jap}
            alt="addLockInstruction1Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={addLockInstruction2Jap}
            alt="addLockInstruction2Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={addLockInstruction3Jap}
            alt="addLockInstruction3Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <h2
            style={{
              backgroundColor: "#5096ff",
              padding: "20px",
              color: "white",
            }}
          >
            メンバー登録
          </h2>
          <img
            className="imgStyle"
            src={inviteMembersIntruction1Jap}
            alt="inviteMembersIntruction1Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={inviteMembersIntruction2Jap}
            alt="inviteMembersIntruction2Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={inviteMembersIntruction3Jap}
            alt="inviteMembersIntruction3Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={inviteMembersIntruction4Jap}
            alt="inviteMembersIntruction4Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />

          <img
            className="imgStyle"
            src={inviteMembersIntruction5Jap}
            alt="inviteMembersIntruction5Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <h2
            style={{
              backgroundColor: "#5096ff",
              padding: "20px",
              color: "white",
            }}
          >
            受信者の追加
          </h2>
          <img
            className="imgStyle"
            src={addRecipient1Jap}
            alt="addRecipient1Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={addRecipient2Jap}
            alt="addRecipient2Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <h2
            style={{
              backgroundColor: "#5096ff",
              padding: "20px",
              color: "white",
            }}
          >
            承認について
          </h2>
          <img
            className="imgStyle"
            src={shareLockInstruction1Jap}
            alt="shareLockInstruction1Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={shareLockInstruction2Jap}
            alt="shareLockInstruction2Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={shareLockInstruction3Jap}
            alt="shareLockInstruction3Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={shareLockInstruction4Jap}
            alt="shareLockInstruction4Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={shareLockInstruction5Jap}
            alt="shareLockInstruction5Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={shareLockInstruction6Jap}
            alt="shareLockInstruction6Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={shareLockInstruction7Jap}
            alt="shareLockInstruction7Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={shareLockInstruction8Jap}
            alt="shareLockInstruction8Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <h2
            style={{
              backgroundColor: "#5096ff",
              padding: "20px",
              color: "white",
            }}
          >
            アクセス権限解除
          </h2>
          <img
            className="imgStyle"
            src={retractLockInstruction1Jap}
            alt="retractLockInstruction1Jap"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
        </div>
      );
    } else if (this.state.currentLanguage === "es") {
      return (
        <div
          style={{
            width: "60%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <h2
            style={{
              backgroundColor: "#5096ff",
              padding: "20px",
              color: "white",
            }}
          >
            Registrarse e Iniciar Sesión
          </h2>
          <img
            className="imgStyle"
            src={loginInstruction1}
            alt="loginInstruction1"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <h2
            style={{
              backgroundColor: "#5096ff",
              padding: "20px",
              color: "white",
            }}
          >
            Canjear o Suscribirse a un Plan
          </h2>
          <img
            className="imgStyle"
            src={subscribeInstruction1}
            alt="subscribeInstruction1"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={subscribeInstruction2}
            alt="subscribeInstruction2"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={subscribeInstruction3}
            alt="subscribeInstruction3"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <h2
            style={{
              backgroundColor: "#5096ff",
              padding: "20px",
              color: "white",
            }}
          >
            Añadir un Candado
          </h2>
          <img
            className="imgStyle"
            src={addLockInstruction1}
            alt="addLockInstruction1"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={addLockInstruction2}
            alt="addLockInstruction2"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={addLockInstruction3}
            alt="addLockInstruction3"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <h2
            style={{
              backgroundColor: "#5096ff",
              padding: "20px",
              color: "white",
            }}
          >
            Invitar a Miembros
          </h2>
          <img
            className="imgStyle"
            src={inviteMembersIntruction1}
            alt="inviteMembersIntruction1"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={inviteMembersIntruction2}
            alt="inviteMembersIntruction2"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={inviteMembersIntruction3}
            alt="inviteMembersIntruction3"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={inviteMembersIntruction4}
            alt="inviteMembersIntruction4"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <h2
            style={{
              backgroundColor: "#5096ff",
              padding: "20px",
              color: "white",
            }}
          >
            Añadir Destinatario
          </h2>
          <img
            className="imgStyle"
            src={addRecipient1}
            alt="addRecipient1"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={addRecipient2}
            alt="addRecipient2"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <h2
            style={{
              backgroundColor: "#5096ff",
              padding: "20px",
              color: "white",
            }}
          >
            Compartir Acceso al Candado
          </h2>
          <img
            className="imgStyle"
            src={shareLockInstruction1}
            alt="shareLockInstruction1"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={shareLockInstruction2}
            alt="shareLockInstruction2"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={shareLockInstruction3}
            alt="shareLockInstruction3"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={shareLockInstruction4}
            alt="shareLockInstruction4"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={shareLockInstruction5}
            alt="shareLockInstruction5"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={shareLockInstruction6}
            alt="shareLockInstruction6"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={shareLockInstruction7}
            alt="shareLockInstruction7"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <h2
            style={{
              backgroundColor: "#5096ff",
              padding: "20px",
              color: "white",
            }}
          >
            Retraer Acceso al Candado
          </h2>
          <img
            className="imgStyle"
            src={retractLockInstruction1}
            alt="retractLockInstruction1"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
        </div>
      );
    }
  }
}

export default FullGuide;
